
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#252626","d":"M12.667 2H3.333C2.597 2 2 2.597 2 3.333v9.334C2 13.403 2.597 14 3.333 14h9.334c.736 0 1.333-.597 1.333-1.333V3.333C14 2.597 13.403 2 12.667 2zm0 10.667H3.333V3.333h9.334v9.334zM4.86 9.653a3.218 3.218 0 011.487 1.487.34.34 0 00.613 0 3.214 3.214 0 011.487-1.487.34.34 0 00.22-.32.34.34 0 00-.194-.293 3.202 3.202 0 01-1.48-1.473.359.359 0 00-.666 0 3.206 3.206 0 01-1.48 1.473.338.338 0 00-.18.293.337.337 0 00.193.32zm3.933-3.44c.434.21.784.56.994.994.04.08.123.13.213.126.084 0 .16-.046.2-.12.208-.434.559-.785.993-.993a.224.224 0 00.14-.22.227.227 0 00-.12-.2 2.122 2.122 0 01-.993-1 .254.254 0 00-.22-.133.252.252 0 00-.22.133 2.118 2.118 0 01-.987.987.199.199 0 00-.126.213c-.013.092.04.18.126.213z"}})])
          )
        }
      }
    